import { Component, AfterViewInit, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: '[app-header]',
  templateUrl: './app-header.component.html',
})
export class AppHeader implements AfterViewInit, OnInit {

  ime: string;
  prezime: string;
  tipKorisnika: string;
  slikaProfila: string;

  constructor(public _router: Router) { }

  ngAfterViewInit() {}

  ngOnInit(){
    this.ime = localStorage.getItem('ime');
    this.prezime = localStorage.getItem('prezime');
    this.tipKorisnika = localStorage.getItem('tipKorisnika'); 
    this.slikaProfila = localStorage.getItem('slikaProfilaURL');
  }
  
  logout(){
    localStorage.clear();
    sessionStorage.clear();
    this._router.navigate(['/login']);
  }

  otvoriProfil(){
    if(this.tipKorisnika == "1"){
      this._router.navigate(['/poslodavac']);
    } else if (this.tipKorisnika == "2"){
      this._router.navigate(['/posloprimac']);
    }
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/layouts/app-header/app-header.component.ts